import { render, staticRenderFns } from "./TpPopover.vue?vue&type=template&id=4f672e70&scoped=true&"
import script from "./TpPopover.vue?vue&type=script&lang=js&"
export * from "./TpPopover.vue?vue&type=script&lang=js&"
import style0 from "./TpPopover.vue?vue&type=style&index=0&id=4f672e70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f672e70",
  null
  
)

export default component.exports